// import countries from "i18n-iso-countries";
import _ from 'lodash';

// export class CountryNames {
//     constructor(locale){
//         this.locale = locale;
//         countries.registerLocale(require("i18n-iso-countries/langs/"+ locale +".json"));
//     }

//     country_name(code) {
//         if (blank(code) || blank(this.locale)) {
//             return '';
//         }        
//         let country = countries.getName(code, this.locale);
//         return country;
//     }
// }

export const propsForMixin = {
    methods: {
        propsFor(componentName, props = this.$props) {
            const cTor = this.$options.components[componentName]
            if (cTor) {
                // locally registered components could be options objects instead of constructors.
                const propOptions = cTor.cid && typeof cTor === 'function'
                    ? cTor.options.props
                    : cTor.props
                const keys = Object.keys(propOptions)
                return _.pick(props, keys) // https://lodash.com/docs/4.17.4#pick
            } else {
                return {}
            }
        }
    }
}